/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function SelectSubject({
  label,
  placeholder,
  name,
  value,
  onChange,
  schoolDetails,
  onBlur,
  errorFormik,
  helperText,
  disabled,
  singleSelection,
  sx,
}) {
  const axiosPrivate = useAxiosPrivate();
  const [subjects, setSubjects] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/subject/getAllSubjects`)
      .then((e) => {
        let filteredSubjects = e.data.data;

        filteredSubjects = filteredSubjects.filter(
          (subject) => subject.status === 1
        );

        if (schoolDetails?.officeTypeId === 2) {
          filteredSubjects = filteredSubjects.filter(
            (subject) => subject.id !== 1 && subject.id !== 8
          );
        }
        setSubjects(filteredSubjects);
      })
      .catch((err) => {
        setError(err.message);
        // console.log("ServiceSelect: ", err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [selectedSubject, setSelectedSubject] = useState(
    singleSelection ? subjects?.find((subject) => subject.id === value) : []
  );

  useEffect(() => {
    handleGetAll();
  }, [schoolDetails]);

  useEffect(() => {
    if (singleSelection) {
      setSelectedSubject(
        subjects?.find((subject) => subject.id === value) || null
      );
    } else {
      setSelectedSubject(
        subjects
          ?.map((sub) => sub?.name)
          .filter((sub) => {
            if (value && value.includes(sub?.name)) {
              return true;
            }
            return false;
          })
      );
    }
  }, [subjects]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);

    if (singleSelection) {
      if (newValue) {
        onChange?.(name, newValue.id || "");
        setSelectedSubject(newValue);
      }
    }
  };

  const handleClear = () => {
    onChange?.(name, singleSelection ? "" : []);
    setSelectedSubject(singleSelection ? null : []);
  };

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={
          // eslint-disable-next-line no-nested-ternary
          singleSelection
            ? selectedSubject && value
              ? selectedSubject?.name
              : ""
            : selectedSubject && value
            ? selectedSubject || null
            : []
        }
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {(singleSelection
                    ? selectedSubject
                    : selectedSubject.length > 0) && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {subjects.map((sub) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={sub?.id}
            onClick={() => {
              if (singleSelection) {
                handleClose(sub);
              } else {
                setSelectedSubject((prev) => {
                  let newValue = prev;

                  if (newValue.includes(sub?.name)) {
                    newValue = newValue.filter((sbjct) => sbjct !== sub?.name);
                  } else {
                    newValue = [...newValue, sub?.name];
                  }

                  onChange?.(name, newValue);
                  return newValue;
                });
              }
            }}
          >
            {!singleSelection && (
              <Checkbox checked={selectedSubject.includes(sub?.name)} />
            )}
            {sub?.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
